export const customPalette = {
  primary0: "#000000",
  primary10: "#002117",
  primary20: "#00382A",
  primary30: "#00513E",
  primary40: "#006C53",
  primary50: "#008769",
  primary60: "#09A480",
  primary70: "#3DBF9A",
  primary80: "#5EDCB5",
  primary90: "#7DF8D0",
  primary95: "#BAFFE4",
  primary99: "#F4FFF8",
  primary100: "#FFFFFF",
  secondary0: "#000000",
  secondary10: "#082018",
  secondary20: "#1E352D",
  secondary30: "#344C42",
  secondary40: "#4C635A",
  secondary50: "#647C72",
  secondary60: "#7D968B",
  secondary70: "#97B1A5",
  secondary80: "#B1CBBF",
  secondary90: "#CBD6D9",
  secondary95: "#E5F0F3",
  secondary99: "#F8FAFC",
  secondary100: "#FFFFFF",
  tertiary0: "#000000",
  tertiary10: "#001E2B",
  tertiary20: "#0C3445",
  tertiary30: "#274B5D",
  tertiary40: "#406375",
  tertiary50: "#597C8F",
  tertiary60: "#7295AA",
  tertiary70: "#8CB0C5",
  tertiary80: "#A7CCE1",
  tertiary90: "#C3E8FE",
  tertiary95: "#E2F3FF",
  tertiary99: "#FBFCFF",
  tertiary100: "#FFFFFF",
  error0: "#000000",
  error10: "#410002",
  error20: "#690005",
  error30: "#93000A",
  error40: "#BA1A1A",
  error50: "#DE3730",
  error60: "#FF5449",
  error70: "#FF7069",
  error80: "#FF8D8A",
  error90: "#FFAAAA",
  error95: "#FFC8C6",
  error99: "#FFE6E5",
  error100: "#FFFFFF",
  neutral0: "#000000",
  neutral10: "#191C1B",
  neutral20: "#2E312F",
  neutral30: "#444845",
  neutral40: "#5C5F5D",
  neutral50: "#757875",
  neutral60: "#8E918F",
  neutral70: "#A9ACA9",
  neutral80: "#C4C7C4",
  neutral90: "#E1E3E0",
  neutral95: "#EFF1EE",
  neutral99: "#FBFDF9",
  neutral100: "#FFFFFF",
  neutralVariant0: "#000000",
  neutralVariant10: "#151D1A",
  neutralVariant20: "#29322E",
  neutralVariant30: "#3F4944",
  neutralVariant40: "#57615C",
  neutralVariant50: "#707974",
  neutralVariant60: "#89938E",
  neutralVariant70: "#A4ADA8",
  neutralVariant80: "#BFC9C3",
  neutralVariant90: "#DBE5DF",
  neutralVariant95: "#E9F3ED",
  neutralVariant99: "#F5FFF8",
  neutralVariant100: "#FFFFFF",
};
